import { Injectable } from '@angular/core'
import { MatCheckbox } from '../../../node_modules/@angular/material';

@Injectable()
export class ExportPPTService {
  pptGlobalIndexMember(dataProvider, radioValue): void {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')
    const slide = pptx.addNewSlide()

    let textMark = ''
    const graphDateList = []
    const graphNoComList = []

    for (let i = 0; i < dataProvider.length; i++) {
      graphDateList.push(dataProvider[i].date)
      graphNoComList.push(dataProvider[i].noOfCompany)
    }

    const dataChartBar = [
      {
        name: 'Number of Company',
        labels: graphDateList,
        values: graphNoComList
      }
    ]

    if (radioValue === 'MSCI') {
      textMark = 'MSCI Thailand (standard)'
    } else if (radioValue === 'DJSI') {
      textMark = 'Dow Jones Sustainability Indices (DJSI)'
    } else {
      textMark = 'Listed companies which market cap. >= 1 bil.USD' + '\n' + 'and Daily avg trading value (past 6 mth) >= $10 mil.USD'
    }

    slide.addChart(pptx.charts.BAR, dataChartBar, {
      x: 1.5,
      y: 2.0,
      w: '70%',
      h: '70%',
      barDir: 'col',
      chartColors: ['ffa400'],
      showTitle: true,
      title: textMark,
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      valAxisTitle: 'Number of Company',
      showValAxisTitle: true,
      valAxisTitleFontFace: 'Browallia New',
      valAxisTitleFontSize: 14,
      catAxisTitleFontFace: 'Browallia New',
      catAxisTitleFontSize: 14,
      catAxisLabelFontFace: 'Browallia New',
      catAxisLabelFontSize: 14,
      valAxisLabelFontFace: 'Browallia New',
      valAxisLabelFontSize: 14,
      catAxisTitle: 'Date',
      showCatAxisTitle: true
    })

    pptx.save('Number of companies of Global standard indices and measurement')
  }

  pptCapitalRaisedByIPOandSO(
    capitalHeader,
    capitalIpovalue,
    capitalSovalue,
    capitalSecurities,
    capitalIpochange,
    capitalSochange,
    textIpoSo
  ): void {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')
    const slide = pptx.addNewSlide()
    const textOpt = {
      x: 0.5,
      y: 1,
      fontFace: 'Browallia New',
      fontSize: 20,
      bold: true
    }
    slide.addText('Capital raised by IPO and SO', textOpt)
    const tableData = []
    const yearList = []
    const ipoSecurityList = []
    const ipoValueList = []
    const ipoChangeList = []
    const soValueList = []
    const soChangeList = []

    const graphYearList = []
    const graphIpoValueList = []
    const graphSoValueList = []

    yearList.push(this.createTableHeader('Year'))
    ipoSecurityList.push('จำนวนหลักทรัพย์ IPO')
    ipoValueList.push('IPO Value (M.Baht)')
    ipoChangeList.push('Change (% yoy)')
    soValueList.push('SO Value (M.Baht)')
    soChangeList.push('Change (% yoy)')

    for (let i = 0; i < capitalHeader.length; i++) {
      graphYearList.push(capitalHeader[i])
      graphIpoValueList.push(capitalIpovalue[i])
      graphSoValueList.push(capitalSovalue[i])

      if (i === capitalHeader.length - 1) {
        yearList.push(this.createTableHeader(capitalHeader[i] + ' YTD'))
      } else {
        yearList.push(this.createTableHeader(capitalHeader[i]))
      }

      ipoSecurityList.push(
        this.createTableDetail(capitalSecurities[i], false, true, false)
      )
      ipoValueList.push(
        this.createTableDetail(capitalIpovalue[i], false, false, true)
      )
      ipoChangeList.push(
        this.createTableDetail(capitalIpochange[i], true, false, false)
      )
      soValueList.push(this.createTableDetail(capitalSovalue[i], false, false, true))
      soChangeList.push(this.createTableDetail(capitalSochange[i], true, false, false))
    }

    tableData.push(yearList)
    tableData.push(ipoSecurityList)
    tableData.push(ipoValueList)
    tableData.push(ipoChangeList)
    tableData.push(soValueList)
    tableData.push(soChangeList)

    const tabOpts = {
      x: 0,
      y: 2.0,
      w: '90%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }
    slide.addTable(tableData, tabOpts)

    const slide2 = pptx.addNewSlide()

    const dataChartBar = [
      {
        name: 'IPO',
        labels: graphYearList,
        values: graphIpoValueList
      },
      {
        name: 'SO',
        labels: graphYearList,
        values: graphSoValueList
      }
    ]

    slide2.addChart(pptx.charts.BAR, dataChartBar, {
      x: 1,
      y: 2,
      w: '80%',
      h: '70%',
      barDir: 'col',
      barGrouping: 'stacked',
      chartColors: ['ffa400', '5f6062'],
      showTitle: true,
      title: 'Capital Raised by IPO and SO',
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      // valAxisLabelFormatCode: '#,##0',
      titleFontSize: 18,
      showLegend: true,
      valAxisTitle: textIpoSo + ' M. Baht',
      showValAxisTitle: true,
      valAxisLabelFormatCode: '#,##0',
      valAxisTitleFontFace: 'Browallia New',
      valAxisTitleFontSize: 14,
      legendFontSize: 14,
      catAxisLabelFontFace: 'Browallia New',
      catAxisLabelFontSize: 14,
      valAxisLabelFontFace: 'Browallia New',
      valAxisLabelFontSize: 14,
      legendPos: 'b'
    })

    pptx.save('Capital raised by IPO and SO')
  }

  pptMarketPerformance(listMarketP, dataChart, ytdValue): void {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')
    const slide = pptx.addNewSlide()
    const textOpt = {
      x: 0.5,
      y: 1,
      fontFace: 'Browallia New',
      fontSize: 20,
      bold: true
    }
    slide.addText('Market performance', textOpt)
    const allIndex = []
    const eachIndex = []
    let chartTypes

    eachIndex.push(this.createTableHeader('Indices'))
    eachIndex.push(this.createTableHeader('Last price (pts)'))
    eachIndex.push(this.createTableHeader('Last P/E (x)'))
    eachIndex.push(this.createTableHeader('Last Market cap (M.Baht)'))
    eachIndex.push(this.createTableHeader('Index change 1D (%)'))
    eachIndex.push(this.createTableHeader('Index change (%)'))
    eachIndex.push(this.createTableHeader('Avg Trading value (M.Baht)'))
    allIndex.push(eachIndex)

    for (let i = 0; i < listMarketP.length; i++) {
      const eachIndexList = []
      eachIndexList.push({
        text: listMarketP[i].indexName,
        options: {
          fontFace: 'Browallia New',
          fontSize: 18,
          valign: 'm',
          align: 'l'
        }
      })
      eachIndexList.push(
        this.createTableDetail(listMarketP[i].indexClose, false, false, false)
      )
      eachIndexList.push(
        this.createTableDetail(listMarketP[i].pe, false, false, false)
      )
      eachIndexList.push(
        this.createTableDetail(Math.round(listMarketP[i].marketCap), false, false, true)
      )
      eachIndexList.push(
        this.createTableDetail(listMarketP[i].indexChange, true, false, false)
      )
      eachIndexList.push(
        this.createTableDetail(listMarketP[i].indexChangeYTD, true, false, false)
      )
      eachIndexList.push(
        this.createTableDetail(Math.round(listMarketP[i].avgTradingValue), false, false, true)
      )
      allIndex.push(eachIndexList)
    }

    const tabOpts = {
      x: 0,
      y: 2.0,
      w: '90%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }
    slide.addTable(allIndex, tabOpts)

    const slide2 = pptx.addNewSlide()

    const graphData = dataChart.dataProvider

    const dateGraph = []
    const setIndexGraph = []
    const set50IndexGraph = []
    const maiIndexGraph = []
    const setMarketCap = []
    const maiMarketCap = []

    if (ytdValue === 0) {
      const months = new Array(12)
      months[0] = 'January'
      months[1] = 'February'
      months[2] = 'March'
      months[3] = 'April'
      months[4] = 'May'
      months[5] = 'June'
      months[6] = 'July'
      months[7] = 'August'
      months[8] = 'September'
      months[9] = 'October'
      months[10] = 'November'
      months[11] = 'December'

      let lastMonth = ''
      for (let i = 0; i < graphData.length; i++) {
        const date = new Date(graphData[i].date)
        if (lastMonth !== months[date.getMonth()]) {
          dateGraph.push(months[date.getMonth()])
          lastMonth = months[date.getMonth()]
        } else {
          dateGraph.push('')
        }
        setIndexGraph.push(graphData[i].setIndex)
        maiIndexGraph.push(graphData[i].maiIndex)
        set50IndexGraph.push(graphData[i].set50Index)
        setMarketCap.push(graphData[i].market1)
        maiMarketCap.push(graphData[i].market2)
      }

      chartTypes = [
        {
          type: pptx.charts.LINE,
          data: [
            {
              name: 'SET index',
              labels: dateGraph,
              values: setIndexGraph
            },
            {
              name: 'SET50 index',
              labels: dateGraph,
              values: set50IndexGraph
            },
            {
              name: 'mai index',
              labels: dateGraph,
              values: maiIndexGraph
            }
          ],
          options: {
            chartColors: ['b35900', '101907', '0039e6'],
            lineDataSymbol: 'none',
            lineSmooth: true
          }
        },
        {
          type: pptx.charts.BAR,
          data: [
            {
              name: 'mai market cap',
              labels: dateGraph,
              values: maiMarketCap
            },
            {
              name: 'SET market cap',
              labels: dateGraph,
              values: setMarketCap
            }
          ],
          options: {
            barDir: 'col',
            barGrouping: 'stacked',
            secondaryValAxis: true,
            secondaryCatAxis: true,
            chartColors: ['5f6062', 'ffa400']
          }
        }
      ]
    } else {
      for (let i = 0; i < graphData.length; i++) {
        const date = new Date(graphData[i].date)

        if (date instanceof Date && isFinite(date.getTime())) {
          dateGraph.push(date.getFullYear())
        } else {
          // dateGraph.push((graphData[i].date).substr(0, 4));
          dateGraph.push((graphData[i].date));

        }

        // dateGraph.push(date.getFullYear())
        setIndexGraph.push(graphData[i].setIndex)
        maiIndexGraph.push(graphData[i].maiIndex)
        set50IndexGraph.push(graphData[i].set50Index)
        setMarketCap.push(graphData[i].market1)
        maiMarketCap.push(graphData[i].market2)
      }

      chartTypes = [
        {
          type: pptx.charts.LINE,
          data: [
            {
              name: 'SET index',
              labels: dateGraph,
              values: setIndexGraph
            },
            {
              name: 'SET50 index',
              labels: dateGraph,
              values: set50IndexGraph
            },
            {
              name: 'mai index',
              labels: dateGraph,
              values: maiIndexGraph
            }
          ],
          options: {
            chartColors: ['b35900', '101907', '0039e6'],
            lineDataSymbol: 'circle',
            lineSmooth: true
          }
        },
        {
          type: pptx.charts.BAR,
          data: [
            {
              name: 'mai market cap',
              labels: dateGraph,
              values: maiMarketCap
            },
            {
              name: 'SET market cap',
              labels: dateGraph,
              values: setMarketCap
            }
          ],
          options: {
            barDir: 'col',
            barGrouping: 'stacked',
            secondaryValAxis: true,
            secondaryCatAxis: true,
            chartColors: ['5f6062', 'ffa400']
          }
        }
      ]
    }

    const multiOpts = {
      x: 0,
      y: 1.0,
      w: '100%',
      h: 6,
      showLegend: true,
      valAxes: [
        {
          showValAxisTitle: true,
          valAxisTitle: 'Index (Point)',
          valAxisTitleFontFace: 'Browallia New',
          valAxisTitleFontSize: 14,
          valGridLine: 'none'
        },
        {
          showValAxisTitle: true,
          valAxisTitle: 'Market Cap (M Baht)',
          valAxisTitleFontFace: 'Browallia New',
          valAxisTitleFontSize: 14
        }
      ],
      catAxes: [
        {
          catAxisTitle: 'Primary Category Axis',
          catAxisLabelFontFace: 'Browallia New',
          catAxisLabelFontSize: 14
        },
        { catAxisHidden: true }
      ],
      showTitle: true,
      title: 'Market Performance',
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      legendPos: 'b',
      valAxisLabelFormatCode: '#,##0'
    }

    slide2.addChart(chartTypes, multiOpts)

    pptx.save('Market Performance')
  }

  pptCapitalRaisedInstruments(
    radioValue2,
    radioValue,
    dataProviderForIpo,
    dataProviderForSo
  ): void {
    let chartTitle
    if (radioValue === '1') {
      chartTitle = 'IPO capital raised by instrument'
    } else {
      chartTitle = 'SO capital raised by instrument'
    }
    let axisX
    radioValue2 === 'M' ? axisX = 'Market cap' : axisX = 'Capital raised'

    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')
    const slide = pptx.addNewSlide()
    const textOpt = {
      x: 0.5,
      y: 1,
      fontFace: 'Browallia New',
      fontSize: 20,
      bold: true
    }
    slide.addText('Capital raised by Instrument', textOpt)
    const tableData = []
    const yearList = []
    const totalList = []

    yearList.push(this.createTableHeader('Year'))
    totalList.push('Total (M.Baht)')
    let dataChartBar
    let chartColors

    const graphYearList = []
    if (radioValue === '1') {
      chartTitle = chartTitle
      const graphSetList = []
      const graphMaiList = []
      const graphIffList = []
      const graphReitList = []
      const setList = []
      const maiList = []
      const iffList = []
      const reitList = []
      setList.push('SET (M.Baht)')
      maiList.push('mai (M.Baht)')
      iffList.push('IFF (M.Baht)')
      reitList.push('PF&REITs (M.Baht)')
      for (let i = 0; i < dataProviderForIpo.length; i++) {
        graphYearList.push(dataProviderForIpo[i].year)
        graphSetList.push((dataProviderForIpo[i].set))
        graphMaiList.push(dataProviderForIpo[i].mai)
        graphIffList.push(dataProviderForIpo[i].iff)
        graphReitList.push(dataProviderForIpo[i].reit)

        if (i === dataProviderForIpo.length - 1) {
          yearList.push(
            this.createTableHeader(dataProviderForIpo[i].year + ' YTD')
          )
        } else {
          yearList.push(this.createTableHeader(dataProviderForIpo[i].year))
        }

        setList.push(this.createTableDetail(dataProviderForIpo[i].set, false, false, true))
        maiList.push(this.createTableDetail(dataProviderForIpo[i].mai, false, false, true))
        iffList.push(this.createTableDetail(dataProviderForIpo[i].iff, false, false, true))
        reitList.push(this.createTableDetail(dataProviderForIpo[i].reit, false, false, true))
        totalList.push(
          this.createTableDetail(
            dataProviderForIpo[i].set +
            dataProviderForIpo[i].mai +
            dataProviderForIpo[i].iff +
            dataProviderForIpo[i].reit,
            false,
            false, true
          )
        )
      }

      tableData.push(yearList)
      tableData.push(setList)
      tableData.push(maiList)
      tableData.push(iffList)
      tableData.push(reitList)
      tableData.push(totalList)

      chartColors = ['ffa400', 'ffd200', '5f6062', '231f20']

      dataChartBar = [
        {
          name: 'SET',
          labels: graphYearList,
          values: graphSetList
        },
        {
          name: 'mai',
          labels: graphYearList,
          values: graphMaiList
        },
        {
          name: 'IFF',
          labels: graphYearList,
          values: graphIffList
        },
        {
          name: 'PF&REITs',
          labels: graphYearList,
          values: graphReitList
        }
      ]
    } else {
      chartTitle = chartTitle
      const ppList = []
      const poList = []
      const roList = []
      const xeList = []
      const sdList = []
      const othersList = []
      ppList.push('PP (M.Baht)')
      poList.push('PO (M.Baht)')
      roList.push('RO (M.Baht)')
      xeList.push('XE (M.Baht)')
      sdList.push('SD (M.Baht)')
      othersList.push('Others (M.Baht)')

      const graphPPList = []
      const graphPOList = []
      const graphROList = []
      const graphXEList = []
      const graphSDList = []
      const graphOtherList = []

      for (let i = 0; i < dataProviderForSo.length; i++) {
        graphYearList.push(dataProviderForSo[i].year)
        graphPPList.push(dataProviderForSo[i].pp)
        graphPOList.push(dataProviderForSo[i].po)
        graphROList.push(dataProviderForSo[i].ro)
        graphXEList.push(dataProviderForSo[i].xe)
        graphSDList.push(dataProviderForSo[i].sd)
        graphOtherList.push(dataProviderForSo[i].other)

        if (i === dataProviderForSo.length - 1) {
          yearList.push(
            this.createTableHeader(dataProviderForSo[i].year + ' YTD')
          )
        } else {
          yearList.push(this.createTableHeader(dataProviderForSo[i].year))
        }
        ppList.push(
          this.createTableDetail(dataProviderForSo[i].pp, false, false, true)
        )
        poList.push(
          this.createTableDetail(dataProviderForSo[i].po, false, false, true)
        )
        roList.push(
          this.createTableDetail(dataProviderForSo[i].ro, false, false, true)
        )
        xeList.push(
          this.createTableDetail(dataProviderForSo[i].xe, false, false, true)
        )
        sdList.push(
          this.createTableDetail(dataProviderForSo[i].sd, false, false, true)
        )
        othersList.push(
          this.createTableDetail(dataProviderForSo[i].other, false, false, true)
        )
        totalList.push(
          this.createTableDetail(
            dataProviderForSo[i].pp +
            dataProviderForSo[i].po +
            dataProviderForSo[i].ro +
            dataProviderForSo[i].xe +
            dataProviderForSo[i].sd +
            dataProviderForSo[i].other,
            false,
            false, true
          )
        )
      }

      tableData.push(yearList)
      tableData.push(ppList)
      tableData.push(poList)
      tableData.push(roList)
      tableData.push(sdList)
      tableData.push(xeList)
      tableData.push(othersList)
      tableData.push(totalList)

      chartColors = ['ffa400', 'ffd200', '5f6062', '231f20', 'b4975a', '009fc2']

      dataChartBar = [
        {
          name: 'PP',
          labels: graphYearList,
          values: graphPPList
        },
        {
          name: 'PO',
          labels: graphYearList,
          values: graphPOList
        },
        {
          name: 'RO',
          labels: graphYearList,
          values: graphROList
        },
        {
          name: 'SD',
          labels: graphYearList,
          values: graphSDList
        },
        {
          name: 'XE',
          labels: graphYearList,
          values: graphXEList
        },
        {
          name: 'Others',
          labels: graphYearList,
          values: graphOtherList
        }
      ]
    }

    const tabOpts = {
      x: 0,
      y: 2.0,
      w: '90%',
      fontFace: 'Browallia New',
      fontSize: 18,  // 18 c2cfd6
      border: { pt: '1', color: 'b3c0c7' },
    }
    slide.addTable(tableData, tabOpts)

    const slide2 = pptx.addNewSlide()

    slide2.addChart(pptx.charts.BAR, dataChartBar, {
      x: 1,
      y: 2,
      w: '80%',
      h: '70%',
      barDir: 'col',
      barGrouping: 'stacked',
      chartColors: chartColors,
      showTitle: true,
      title: chartTitle,
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      showLegend: true,
      valAxisTitle: axisX + ' (M. Baht)',
      showValAxisTitle: true,
      valAxisLabelFormatCode: '#,##0',
      valAxisTitleFontFace: 'Browallia New',
      valAxisTitleFontSize: 14,
      legendFontSize: 14,
      catAxisLabelFontFace: 'Browallia New',
      catAxisLabelFontSize: 14,
      valAxisLabelFontFace: 'Browallia New',
      valAxisLabelFontSize: 14,
      legendPos: 'b'


    })

    pptx.save(chartTitle)
  }

  numberWithCommas(x, isInteger): string {
    let parts
    if (!isInteger) {
      parts = Number(x)
        .toFixed(2)
        .split('.')
    } else {
      parts = x.toString().split('.')
    }
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
  }

  formatValue(value, isInteger): string {
    if (value === 0) {
      return '0.00'
    } else if (value === null) {
      return 'N/A'
    } else {
      return this.numberWithCommas(value, isInteger)
    }
  }

  createTableHeader(
    text
  ): {
      text: string
      options: {
        color: string
        fill: string
        fontFace: string
        fontSize: number
        valign: string
        align: string
      }
    } {
    const tableHeader = {
      text: '',
      options: {
        color: '000000',
        fill: 'c2cfd6',
        fontFace: 'Browallia New',
        fontSize: 18,
        valign: 'm',
        align: 'c'
      }
    }
    tableHeader.text = text
    return tableHeader
  }

  createTableDetail(
    text,
    isPercent,
    isInteger,
    isMbaht
  ): {
      text: string
      options: {
        fontFace: string
        fontSize: number
        valign: string
        align: string
      }
    } {
    const tableDetail = {
      text: '',
      options: {
        fontFace: 'Browallia New',
        fontSize: 18,
        valign: 'm',
        align: 'r'
      }
    }
    if (text) {
      if (isPercent) {
        // tableDetail.text = this.formatValue(text, isInteger) + '%'
        tableDetail.text = this.formatValue(text, isInteger);

      } else {
        tableDetail.text = this.formatValue(text, isInteger);
        if (isMbaht) {
          tableDetail.text = this.formatValueNoDecimal(tableDetail.text);
        }
      }
    } else {
      tableDetail.text = '0';
    }
    return tableDetail
  }

  pptHistoricalIndices(indicesData, displayIndex): void {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')

    const slide = pptx.addNewSlide()
    const dateGraph = []
    const setIndexGraph = []
    const maiIndexGraph = []
    const setMarketCap = []
    const maiMarketCap = []
    let chartTypes = []
    if (displayIndex === 'set') {
      for (let i = 0; i < indicesData.length; i++) {
        const date = new Date(indicesData[i].date)
        dateGraph.push(indicesData[i].year)
        setIndexGraph.push(indicesData[i].setIndex)
        setMarketCap.push(indicesData[i].setMarketCap)
      }
      chartTypes = [
        {
          type: pptx.charts.LINE,
          data: [
            {
              name: 'SET index',
              labels: dateGraph,
              values: setIndexGraph
            }
          ],
          options: {
            chartColors: ['b35900'],
            lineDataSymbol: 'none',
            lineSmooth: true
          }
        },
        {
          type: pptx.charts.BAR,
          data: [
            {
              name: 'SET market cap',
              labels: dateGraph,
              values: setMarketCap
            }
          ],
          options: {
            barDir: 'col',
            barGrouping: 'stacked',
            secondaryValAxis: true,
            secondaryCatAxis: true,
            chartColors: ['FFBF00']
          }
        }
      ]
    } else if (displayIndex === 'mai') {
      for (let i = 0; i < indicesData.length; i++) {
        const date = new Date(indicesData[i].date)
        dateGraph.push(indicesData[i].year)
        maiIndexGraph.push(indicesData[i].maiIndex)
        maiMarketCap.push(indicesData[i].maiMarketCap)
      }
      chartTypes = [
        {
          type: pptx.charts.LINE,
          data: [
            {
              name: 'mai index',
              labels: dateGraph,
              values: maiIndexGraph
            }
          ],
          options: {
            chartColors: ['20acd4'],
            lineDataSymbol: 'none',
            lineSmooth: true
          }
        },
        {
          type: pptx.charts.BAR,
          data: [
            {
              name: 'mai market cap',
              labels: dateGraph,
              values: maiMarketCap
            }
          ],
          options: {
            barDir: 'col',
            barGrouping: 'stacked',
            secondaryValAxis: true,
            secondaryCatAxis: true,
            chartColors: ['848484']
          }
        }
      ]
    } else if (displayIndex === '') {
      for (let i = 0; i < indicesData.length; i++) {
        const date = new Date(indicesData[i].date)
        dateGraph.push(indicesData[i].year)
        setIndexGraph.push(indicesData[i].setIndex)
        maiIndexGraph.push(indicesData[i].maiIndex)
        setMarketCap.push(indicesData[i].setMarketCap)
        maiMarketCap.push(indicesData[i].maiMarketCap)
      }
      chartTypes = [
        {
          type: pptx.charts.LINE,
          data: [
            {
              name: 'SET index',
              labels: dateGraph,
              values: setIndexGraph
            },
            {
              name: 'mai index',
              labels: dateGraph,
              values: maiIndexGraph
            }
          ],
          options: {
            chartColors: ['b35900', '20acd4'],
            lineDataSymbol: 'none',
            lineSmooth: true
          }
        },
        {
          type: pptx.charts.BAR,
          data: [
            {
              name: 'SET market cap',
              labels: dateGraph,
              values: setMarketCap
            },
            {
              name: 'mai market cap',
              labels: dateGraph,
              values: maiMarketCap
            }
          ],
          options: {
            barDir: 'col',
            barGrouping: 'stacked',
            secondaryValAxis: true,
            secondaryCatAxis: true,
            chartColors: ['FFBF00', '5f6062']
          }
        }
      ]
    }

    const multiOpts = {
      x: 1.0,
      y: 2.0,
      w: '80%',
      h: '70%',
      showLegend: true,
      valAxisLabelFormatCode: '#,##0',
      titleFontFace: 'Browallia New',
      legendPos: 'b',
      valAxes: [
        {
          showValAxisTitle: true,
          valAxisTitle: 'Index (Point)',
          valAxisTitleFontFace: 'Browallia New',
          valAxisLabelFormatCode: '#,##0',
          valAxisTitleFontSize: 14,
          valGridLine: 'none',
          valAxisMinVal: '0'
        },
        {
          showValAxisTitle: true,
          valAxisTitle: 'Market cap (M Baht)',
          valAxisTitleFontFace: 'Browallia New',
          valAxisLabelFormatCode: '#,##0',
          valAxisTitleFontSize: 14,
          valAxisMinVal: 0
        }
      ],
      catAxes: [
        {
          catAxisTitle: 'Primary Category Axis',
          catAxisLabelFontFace: 'Browallia New',
          catAxisLabelFontSize: 14
        },
        { catAxisHidden: true }
      ],
      showTitle: true,
      title: 'Historical Indices and market cap',
      titleAlign: 'center'
    }

    slide.addChart(chartTypes, multiOpts)

    pptx.save('Historical Indices')
  }

  pptExistingListedSecurities(dataProvider, listedSecuritiesByType, ipoSecuritiesByType) {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')

    const slide = pptx.addNewSlide()
    const dateGraph = []
    const listedSecurityGraph = []
    const newListedIPOGraph = []

    for (let i = 0; i < dataProvider.length; i++) {
      dateGraph.push(dataProvider[i].year)
      listedSecurityGraph.push(dataProvider[i].securities)
      newListedIPOGraph.push(dataProvider[i].newIpo)
    }

    const chartTypes = [
      {
        type: pptx.charts.BAR,
        data: [
          {
            name: 'Number of new IPO (Right)',
            labels: dateGraph,
            values: newListedIPOGraph
          }
        ],
        options: {
          barDir: 'col',
          secondaryValAxis: true,
          secondaryCatAxis: true,
          chartColors: ['FFBF00']
        }
      },
      {
        type: pptx.charts.LINE,
        data: [
          {
            name: 'Number of listed securities (Common stock and PF/REITs) (Left)',
            labels: dateGraph,
            values: listedSecurityGraph
          }
        ],
        options: {
          chartColors: ['0000ff'],
          lineDataSymbol: 'circle'
        }
      },
    ]

    const multiOpts = {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      showLegend: true,
      valAxisMinVal: 0,
      valAxisLabelFormatCode: '#,##0',
      valAxes: [
        {
          showValAxisTitle: true,
          valAxisTitle:
            'Number of listed securities\n(Common stock and PF/REITs)',
          valAxisTitleFontFace: 'Browallia New',
          valAxisTitleFontSize: 14,
          valGridLine: 'none'
        },
        {
          showValAxisTitle: true,
          valAxisTitle: 'Number of new IPO',
          valAxisTitleFontFace: 'Browallia New',
          valAxisTitleFontSize: 14
        }
      ],
      catAxes: [
        {
          catAxisTitle: 'Year',
          catAxisLabelFontFace: 'Browallia New',
          catAxisLabelFontSize: 14
        },
        { catAxisHidden: true }
      ],
      showTitle: true,
      title: 'New and Existing Listed Securities',
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      legendPos: 'b'
    }

    slide.addChart(chartTypes, multiOpts)

    const tabOpts = {
      x: 1,
      y: 1,
      w: '20%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }

    const slide2 = pptx.addNewSlide();
    var rows = [];
    for (let i = 0; i < listedSecuritiesByType.length; i++) {
      rows.push([this.createTableHeader(listedSecuritiesByType[i].type), this.createTableDetail(listedSecuritiesByType[i].noListedCompany, false, true, false)]);
    }
    slide2.addText('Listed securities by type', {x: 1, y: 0.5, fontFace: 'Browallia New', fontSize: 22, bold: true});
    slide2.addTable( rows, tabOpts );

    const tabOpts2 = {
      x: 1,
      y: 4,
      w: '20%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }

    var rows = [];
    for (let i = 0; i < ipoSecuritiesByType.length; i++) {
      rows.push([this.createTableHeader(ipoSecuritiesByType[i].type), this.createTableDetail(ipoSecuritiesByType[i].noListedCompany, false, true, false)]);
    }
    slide2.addText('IPO securities by type', {x: 1, y: 3.5, fontFace: 'Browallia New', fontSize: 22, bold: true});
    slide2.addTable( rows, tabOpts2 );

    pptx.save('New and Existing Listed Securities')
  }

  pptIpoExchangeFiveYears(dataProviderForIpoCap, ipoHeader, textmark) {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')

    const slide = pptx.addNewSlide()
    const textOpt = {
      x: 0.5,
      y: 1,
      fontFace: 'Browallia New',
      fontSize: 20,
      bold: true
    }
    slide.addText('Initial public offering in ASEAN exchanges in 5 years (M. USD)', textOpt)
    const dataTable = []
    dataTable.push(ipoHeader.map(h => this.createTableHeader(h)))
    dataProviderForIpoCap.map(data => {
      const detailList = []
      detailList.push(data.country + ' ' + data.market)
      detailList.push(this.createTableDetail(data.year1, false, false, true))
      detailList.push(this.createTableDetail(data.year2, false, false, true))
      detailList.push(this.createTableDetail(data.year3, false, false, true))
      detailList.push(this.createTableDetail(data.year4, false, false, true))
      detailList.push(this.createTableDetail(data.year5, false, false, true))
      detailList.push(this.createTableDetail(data.total, false, false, true))
      dataTable.push(detailList)
    })

    const tabOpts = {
      x: 0,
      y: 1.5,
      w: '90%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }
    slide.addTable(dataTable, tabOpts)

    const slide2 = pptx.addNewSlide()

    const countryList = []
    const year1List = []
    const year2List = []
    const year3List = []
    const year4List = []
    const year5List = []

    for (let i = 0; i < dataProviderForIpoCap.length; i++) {
      countryList.push(dataProviderForIpoCap[i].country)
      year1List.push(dataProviderForIpoCap[i].year1)
      year2List.push(dataProviderForIpoCap[i].year2)
      year3List.push(dataProviderForIpoCap[i].year3)
      year4List.push(dataProviderForIpoCap[i].year4)
      year5List.push(dataProviderForIpoCap[i].year5)
    }

    const dataChart = [
      {
        name: ipoHeader[1] + '',
        labels: countryList,
        values: year1List
      },
      {
        name: ipoHeader[2] + '',
        labels: countryList,
        values: year2List
      },
      {
        name: ipoHeader[3] + '',
        labels: countryList,
        values: year3List
      },
      {
        name: ipoHeader[4] + '',
        labels: countryList,
        values: year4List
      },
      {
        name: ipoHeader[5] + '',
        labels: countryList,
        values: year5List
      }
    ]

    const multiOpts = {
      barDir: 'col',
      chartColors: ['5f6062', 'D6D6DA', 'ffd200', 'fbb034', 'f98500'],
      x: 1.0,
      y: 2.0,
      w: '80%',
      h: '70%',
      valAxisMinVal: 0,
      showValAxisTitle: true,
      valAxisLabelFormatCode: '#,##0',
      valAxisTitle: textmark + ' (M. USD)',
      valAxisTitleFontFace: 'Browallia New',
      valAxisTitleFontSize: 14,
      catAxisTitle: 'Country',
      catAxisLabelFontFace: 'Browallia New',
      catAxisLabelFontSize: 14,
      catAxisHidden: false,
      showTitle: true,
      title: 'Initial Public Offering in ASEAN Exchanges in 5 years',
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      legendPos: 'b',
      showLegend: true,
      legendFontSize: 14,
      valAxisLabelFontFace: 'Browallia New',
      valAxisLabelFontSize: 14,
    }

    slide2.addChart(pptx.charts.BAR, dataChart, multiOpts)

    pptx.save('Initial Public Offering in ASEAN Exchanges in 5 years')
  }

  pptProfit(listYear, dataProvider, listProfitData, listHeader) {
    const PptxGenJS = require('pptxgenjs')
    const pptx = new PptxGenJS()

    pptx.setBrowser(true)
    pptx.setLayout('LAYOUT_WIDE')

    const slide = pptx.addNewSlide()
    const textOpt = {
      x: 0.5,
      y: 0.5,
      fontFace: 'Browallia New',
      fontSize: 20,
      bold: true
    }
    slide.addText('Net profit in ASEAN exchanges in 5 years (M. USD)', textOpt)


    const dataTable = []
    dataTable.push(listHeader.map(h => this.createTableHeader(h)))

    listProfitData.map(data => {
      const detailList = []
      detailList.push(data.market)
      detailList.push(this.createTableDetail(data.pts, false, false, false))
      detailList.push(this.createTableDetail(data.pe, false, false, false))
      detailList.push(this.createTableDetail(data.indexChange, false, false, false))
      detailList.push(this.createTableDetail(data.year1, false, true, false))
      detailList.push(this.createTableDetail(data.year2, false, true, false))
      detailList.push(this.createTableDetail(data.year3, false, true, false))
      detailList.push(this.createTableDetail(data.year4, false, true, false))
      detailList.push(this.createTableDetail(data.ytd, false, true, false))
      detailList.push(this.createTableDetail(data.total, false, true, false))
      dataTable.push(detailList)
    })

    const tabOpts = {
      x: 0,
      y: 1.5,
      w: '90%',
      fontFace: 'Browallia New',
      fontSize: 18,
      border: { pt: '1', color: 'c2cfd6' }
    }
    slide.addTable(dataTable, tabOpts)

    const slide2 = pptx.addNewSlide()


    const countryList = []
    const year1List = []
    const year2List = []
    const year3List = []
    const year4List = []
    const year5List = []

    for (let i = 0; i < dataProvider.length; i++) {
      countryList.push(dataProvider[i].category)
      year1List.push(dataProvider[i].year1)
      year2List.push(dataProvider[i].year2)
      year3List.push(dataProvider[i].year3)
      year4List.push(dataProvider[i].year4)
      year5List.push(dataProvider[i].year5)
    }
    const dataChart = [
      {
        name: listYear[0] + '',
        labels: countryList,
        values: year1List
      },
      {
        name: listYear[1] + '',
        labels: countryList,
        values: year2List
      },
      {
        name: listYear[2] + '',
        labels: countryList,
        values: year3List
      },
      {
        name: listYear[3] + '',
        labels: countryList,
        values: year4List
      },
      {
        name: 'YTD' + '',
        labels: countryList,
        values: year5List
      }
    ]
    const multiOpts = {
      x: 1.0,
      y: 2.0,
      w: '80%',
      h: '70%',
      barDir: 'col',
      chartColors: ['5f6062', 'D6D6DA', 'ffd200', 'fbb034', 'f98500'],
      showTitle: true,
      title: 'Net profit in ASEAN Exchanges in 5 years',
      titleAlign: 'center',
      titleFontFace: 'Browallia New',
      titleFontSize: 18,
      showLegend: true,
      valAxisTitle: 'Net Profit (M. USD)',
      showValAxisTitle: true,
      valAxisLabelFormatCode: '#,##0',
      valAxisTitleFontFace: 'Browallia New',
      valAxisTitleFontSize: 14,
      legendFontSize: 14,
      catAxisLabelFontFace: 'Browallia New',
      catAxisLabelFontSize: 14,
      valAxisLabelFontFace: 'Browallia New',
      valAxisLabelFontSize: 14,
      legendPos: 'b'
    }
    slide2.addChart(pptx.charts.BAR, dataChart, multiOpts)
    pptx.save('Net Profit')
  }

  formatValueNoDecimal(value) {
    if (!!value) {
      const parts = value.toString().split('.')
      return parts[0];
    } else {
      return value;
    }

  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/export-ppt.service.ts